var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('QuantityCalculator',{attrs:{"quantity":_vm.item.getQuantity(),"stockCount":_vm.item.getStockCount(),"min":_vm.item.getMinCount(),"max":_vm.item.getMaxCount(),"onAddEvent":_vm.addQuantity,"onSubEvent":_vm.subQuantity}})}
var staticRenderFns = []

export { render, staticRenderFns }